import { FC, useContext, useState } from "react";

import Icon from "@/components/ui/Icon/Icon";
import { UserContext } from "@/context/UserContext";
import { LoginType } from "@/types";

import { useNotification } from "../NotificationProvider/NotificationProvider";

export interface SoftLoginProps {
  icon?: {
    notLoggedIcon: string;
    loggedIcon: string;
  };
  text?: {
    notLoggedText: string;
    loggedText: string;
  };
  iconClass?: string;
  onLogin?: (success: boolean, otpError?: boolean) => void;
  label?: string;
  labelClass?: string;
}

const SoftLogin: FC<SoftLoginProps> = ({ icon, text, iconClass, onLogin, labelClass, label }) => {
  const [loginType, setLoginType] = useState<LoginType>();
  const { isLoggedIn } = useContext(UserContext);
  const { setSoftLoginModalOpen } = useNotification();

  return (
    <>
      {icon && (
        <div
          onClick={() => {
            if (!isLoggedIn) {
              setSoftLoginModalOpen(true);
            }
          }}
          title={loginType}
          className={label && "flex flex-col items-center"}
        >
          <Icon name={isLoggedIn ? icon.loggedIcon : icon.notLoggedIcon} size="24" className={iconClass ? iconClass : "stroke-black"} />
          {label && <span className={labelClass}>{label}</span>}
        </div>
      )}
      {text && <span>{isLoggedIn ? text.loggedText : text.notLoggedText}</span>}
    </>
  );
};
export default SoftLogin;
